<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import { ALL_SCORE_PROVIDERS } from '../../Constants/ScoreProviderName'

export default {
  components: { BlockContent },
  props: {
    simulation: { type: Object, default: {} },
    def: { type: Object, default: {} },
  },

  mixins: [mixinComponent, globalVariablesMixin],

  computed: {
    value() {
      if (this.conf.scoreProvider && this.simulation.client) {
        const scoreProvider = this.simulation.client.lastScoreForAllProviders.find((score) =>
          ALL_SCORE_PROVIDERS[this.conf.scoreProvider].includes(score.provider),
        )

        if (scoreProvider) {
          if (ALL_SCORE_PROVIDERS['creditsafeconnect'].includes(scoreProvider.provider)) {
            return scoreProvider.score / this.maxValue
          }

          return scoreProvider.score
        }
      }

      return this.simulation.score ?? 0
    },
    maxValue() {
      return 10
    },
    progressWidth() {
      return (this.value / this.maxValue) * 100
    },
    textColor() {
      return {
        'text-danger': this.progressWidth < 30,
        'text-warning': this.progressWidth >= 30 && this.progressWidth < 50,
        'text-success': this.progressWidth >= 50,
      }
    },
    progressBarColor() {
      return {
        'bg-danger': this.progressWidth < 30,
        'bg-warning': this.progressWidth >= 30 && this.progressWidth < 50,
        'bg-success': this.progressWidth >= 50,
      }
    },
  },
}
</script>
<template>
  <div id="d_proposition_notation" class="row">
    <div class="col-12">
      <BlockContent :title="$t('simulation.result.notation')" e2e-block="simulationNotation">
        <div class="card shadow-1">
          <div class="card-body">
            <div class="text-center my-2">
              <div class="fs-60 fw-400">
                <span :class="textColor" e2e-data="simulationNotationScore">{{ $n(Number(value)) }}</span>
              </div>
              <span class="fw-400 text-muted">/{{ maxValue }}</span>
            </div>
          </div>
          <div class="progress mb-0">
            <div
              class="progress-bar"
              :class="progressBarColor"
              role="progressbar"
              :style="{ width: progressWidth + '%', height: '3px' }"
              :aria-valuenow="value"
              aria-valuemin="0"
              :aria-valuemax="maxValue"
            ></div>
          </div>
        </div>
      </BlockContent>
    </div>
  </div>
</template>
